import React from 'react';
import { useParams, generatePath } from "react-router";
import { useDataValue } from 'globals/contexts/dataContext';
import { useHistory } from 'react-router-dom';
import routes from 'globals/routes';

import './eventSection.css';
import './eventSectionMobile.css';

const LandingSection = ({filters, content: pageContent}) => {
  // const  = props['content'];
  const [{currentLanguage}, dispatch] = useDataValue();
  const history = useHistory();
  // const logoUrl = content['logo'];
  const setCurrentEvent = (eventIdx) => {
    // console.log("clicked!!", eventIdx);
  // dispatch({
    //   type: 'setCurrentEvent',
    //   data: eventIdx
    // });
    // dispatch({
    //   type: 'setCurrentPage',
    //   data: 'event'
    // });
    history.push(generatePath(routes.eventPage, {
      eventname: eventIdx,
      lang: currentLanguage
    }));
  }
  return <section className="event" id="event">
    <div className="sectionTitle">{pageContent['title']}</div>
    <div className="eventWrapper">
      {pageContent['items']
        .filter((item) => item['featured'] != "1")
        .map((item, idx) => {
        return <div className="eventItem" onClick={() => setCurrentEvent(item['title'])}>
          <div className="imageWrapper">
            <div className="month">
              <div className="verticalText zh">{item['month'][0]}</div>
              <div className="seperator" />
              <div className="verticalText en">{item['month'][1]}</div>
            </div>
            <img src={item['image']} />
          </div>
          <div className="eventTitle">{item['title']}</div>
          <div className="eventType">{item['type']}</div>
          <div className="detailButton">{currentLanguage == 'tc'? '了解更多': 'DETAILS'}</div>
        </div>;
      })}
    </div>
  </section>;
}

export default LandingSection;